import {formatarMoedaBRL} from '../mask';
interface Item {
  camapanha: string;
  camapanha_id: number;
  channel_name: string;
  district: string;
  invoice_date: string;
  producer_name: string;
  product_name: string;
  regional_name: string;
  state_code: string;
  total_value: string;
  volume_kg_lt: string;
}

type GenerateHtmlParams = {
  producerInfo: any;
  title: string;
  boxA: Item[];
  boxB: Item[];
};

export const generateHtml = ({
  producerInfo,
  title,
  boxA,
  boxB
}: GenerateHtmlParams): string => {


  const camapanhaA = boxA.length > 0 ? boxA[0].camapanha : 'N/A';
  const camapanhaB = boxB.length > 0 ? boxB[0].camapanha : 'N/A';


  return `
    <div style="
      width: 100%;
      background: #fff;
      padding: 40px 0;
      display: flex;
      justify-content: center;
      align-items: center;
      font-family: Arial, sans-serif;
      color: black;
    ">
      <div style="
        width: 100%;
        max-width: 1000px;
        background: #efefef;
        border-radius: 5px;
        padding: 20px;
        display: grid;
        grid-template-rows: auto 1fr;
        grid-template-columns: 1fr 1fr;
        gap: 10px;
        color: black;
      ">
        <div style="
          grid-column: 1 / 3;
          padding: 10px;
          width: 100%;
          background: #fff;
          text-align: center;
          color: black;
        ">
          <div style="margin-top: 20px; line-height: 1.2; color: black;">
            <strong>${producerInfo.name}</strong>
            <h3 style="margin: 5px 0; color: black;">${title}</h3>
          </div>
        </div>

        <div style="width: 100%; background: #fff; color: black;">
          <table style="width: 100%; border-collapse: collapse;">
            <thead>
              <tr>
                <th colspan="4" style="padding: 10px; background: #fff; color: black;">Safra ${camapanhaA}</th>
              </tr>
              <tr>
                <td style="background: #efefef; font-weight: bold; padding: 10px; color: black;">Data da NF</td>
                <td style="background: #efefef; font-weight: bold; padding: 10px; color: black;">Produto</td>
                <td style="background: #efefef; font-weight: bold; padding: 10px; color: black;">Volume total (KG/L)</td>
                <td style="background: #efefef; font-weight: bold; padding: 10px; color: black;">Valor total (R$)</td>
              </tr>
            </thead>
            <tbody>
              ${boxA.map(item => `
                <tr>
                  <td style="padding: 10px; border-bottom: 1px solid #ccc; color: black;">${item.invoice_date}</td>
                  <td style="padding: 10px; border-bottom: 1px solid #ccc; color: black;">${item.product_name}</td>
                  <td style="padding: 10px; border-bottom: 1px solid #ccc; color: black;">${formatarMoedaBRL(item.volume_kg_lt)}</td>
                  <td style="padding: 10px; border-bottom: 1px solid #ccc; color: black;">${formatarMoedaBRL(item.total_value)}</td>
                </tr>
              `).join('')}
            </tbody>
          </table>
        </div>

        <div style="width: 100%; background: #fff; color: black;">
          <table style="width: 100%; border-collapse: collapse;">
            <thead>
              <tr>
                <th colspan="4" style="padding: 10px; background: #fff; color: black;">Safra  ${camapanhaB}</th>
              </tr>
              <tr>
                <td style="background: #efefef; font-weight: bold; padding: 10px; color: black;">Data da NF</td>
                <td style="background: #efefef; font-weight: bold; padding: 10px; color: black;">Produto</td>
                <td style="background: #efefef; font-weight: bold; padding: 10px; color: black;">Volume total (KG/L)</td>
                <td style="background: #efefef; font-weight: bold; padding: 10px; color: black;">Valor total (R$)</td>
              </tr>
            </thead>
            <tbody>
              ${boxB.map(item => `
                <tr>
                  <td style="padding: 10px; border-bottom: 1px solid #ccc; color: black;">${item.invoice_date}</td>
                  <td style="padding: 10px; border-bottom: 1px solid #ccc; color: black;">${item.product_name}</td>
                  <td style="padding: 10px; border-bottom: 1px solid #ccc; color: black;">${formatarMoedaBRL(item.volume_kg_lt)}</td>
                  <td style="padding: 10px; border-bottom: 1px solid #ccc; color: black;">${formatarMoedaBRL(item.total_value)}</td>
                </tr>
              `).join('')}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  `;
};